import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
import './lib/foundation-explicit-pieces';


$(document).foundation();


import * as func from './helpers/functions';
import CheckPassword from './lib/checkPassword';
import Confirm from './lib/confirm';
import CopyText from './lib/copyText';
import Datepicker from './lib/datepicker';
import Jumplink from './lib/jumplink';
import Nav from './lib/nav';
import PageTop from './lib/pageTop';
import RestrictPageInputs from './lib/restrictPageInputs';
import Textarea from './lib/textarea';

(function(window, document) {
    CheckPassword.setup();
    Confirm.setup();
    CopyText.setup();
    Datepicker.setup();
    Jumplink.setup();
    Nav.setup();
    PageTop.setup();
    RestrictPageInputs.setup();
    Textarea.setup();
})(window, window.document);